import React from 'react';

const InputField = ({ icon, type, input, placeholder, meta }) => (
    <div className="input-group input-group-alternative">
        <div className="input-group-prepend">
            <span className="input-group-text">
                <i className={`ni ${icon}`} />
            </span>
        </div>
        <input
            className="form-control"
            placeholder={placeholder}
            type={type}
            {...input}
        />
        {meta.error && meta.touched && <span className="pl-1 small text-danger">{meta.error}</span>}
    </div>
);

export default InputField;



// WEBPACK FOOTER //
// ./src/components/Pages/Login/InputField.js